/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useState } from "react";
import { BrickLoader, Button, ExtendedTooltip, theme } from "@nordcloud/gnui";
import { Resource, ResourceComplianceStatusInfo } from "~/generated/graphql";
import { complianceStatusDetails } from "../const";
import type { ComplianceStatus } from "../types";
import { UpdatesModal } from "../UpdatesModal/UpdatesModal";

type Props = {
  complianceStatusesLoading: boolean;
  complianceStatuses: ResourceComplianceStatusInfo[];
  resource: Resource;
};

export function ComplianceStatusButton({
  complianceStatusesLoading,
  complianceStatuses,
  resource,
}: Props) {
  const [isComplianceModalOpen, setComplianceModalOpen] = useState(false);

  if (complianceStatusesLoading) {
    return <BrickLoader height={"2rem"} />;
  }

  const statusData = complianceStatuses.find(
    (status) => status.resourceId === resource.id
  );
  const status: ComplianceStatus = statusData?.status ?? "N/A";
  const details = complianceStatusDetails[status];

  return (
    <>
      {isComplianceModalOpen && (
        <UpdatesModal
          isOpen={isComplianceModalOpen}
          onClose={() => setComplianceModalOpen(false)}
          resourceId={resource.id}
          complianceStatus={status}
          resource={{
            id: resource.id,
            name: resource.name,
            os: resource.os?.type ?? null,
          }}
        />
      )}
      <ExtendedTooltip
        caption={details.tooltip}
        placement="top"
        status={details.uiStatus}
      >
        <Button
          icon={!details.disabled ? "chevronRight" : undefined}
          iconRight
          size="md"
          status={details.uiStatus}
          disabled={details.disabled}
          onClick={
            details.disabled ? undefined : () => setComplianceModalOpen(true)
          }
          css={{
            justifyContent: "center",
            position: "relative",
            alignItems: "center",
            textTransform: "none",
            "& svg": {
              position: "absolute",
              right: theme.spacing.spacing01,
            },
            width: "140px",
          }}
        >
          {details.label}
        </Button>
      </ExtendedTooltip>
    </>
  );
}
